import { IGeneralStatus } from "models/GeneralStatusModel";
import { BaseService } from "./base.service";

class GeneralStatusServiceInternal extends BaseService {
	getGeneralStatusList = async (): Promise<IGeneralStatus[]> =>
		this.callApi<IGeneralStatus[]>(`GeneralStatus/GetGeneralStatusList`, "GET");
}

export const GeneralStatusService = new GeneralStatusServiceInternal();
